import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    STORE_GROUP_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from 'src/routing/components';

export const Routes = [
    {
        exact: true,
        path: '/create/store-group',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_GROUP_PERMISSION,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/storeGroup/StoreGroupCreateView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: STORE_GROUP_PERMISSION,
            crud: READ_PERMISSION,
        },
        path: '/management/store-groups',
        component: lazy(() => import('src/views/storeGroup/StoreGroupListView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: STORE_GROUP_PERMISSION,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/store-groups/:id/edit',
        component: lazy(() => import('src/views/storeGroup/StoreGroupEditView')),
    },
];
